var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { BdGraphNode, BdGraph } from './graph.model';
export var GraphUtils;
(function (GraphUtils) {
    // get node data if it exists, otherwise return null
    function getNode(graph, id) {
        return graph.nodes[id] || null;
    }
    GraphUtils.getNode = getNode;
    // get nearest ancestor if it exists, otherwise return null
    // this is a (private) utility 
    function getAncestor(graph, id) {
        return graph.predecessors[id] || null;
    }
    GraphUtils.getAncestor = getAncestor;
    // union of all immediate ancestors of a set of nodes
    function getAllAncestorsFromList(graph, targets) {
        var ancestors = {};
        var _ancestor;
        targets.forEach(function (id) {
            _ancestor = getAncestor(graph, id);
            if (_ancestor && !ancestors[_ancestor]) {
                ancestors[_ancestor] = true;
            }
        });
        return Object.keys(ancestors);
    }
    GraphUtils.getAllAncestorsFromList = getAllAncestorsFromList;
    // return all child node ids of target node
    function getSuccessors(graph, id) {
        return __spread(graph.successors[id] || []);
    }
    GraphUtils.getSuccessors = getSuccessors;
    // get graph node state matching properties
    function getState(graph, id, properties) {
        var state = {};
        var node = getNode(graph, id);
        Object.entries(node.boolState).forEach(function (_a) {
            var _b = __read(_a, 2), property = _b[0], value = _b[1];
            if (properties && properties.includes(property)) {
                state[property] = value;
            }
        });
        Object.entries(node.numState).forEach(function (_a) {
            var _b = __read(_a, 2), property = _b[0], value = _b[1];
            if (properties && properties.includes(property)) {
                state[property] = value;
            }
        });
        return state;
    }
    GraphUtils.getState = getState;
    // return true if node is a leaf node
    function isLeaf(graph, id) {
        return !!graph.nodes[id] && graph.successors[id] === undefined;
    }
    GraphUtils.isLeaf = isLeaf;
    // return true if node is a root node
    function isRoot(graph, id) {
        return graph.roots.hasOwnProperty(id) || false;
    }
    GraphUtils.isRoot = isRoot;
    // return all root-node ids
    function getRoots(graph) {
        return Object.keys(graph.roots);
    }
    GraphUtils.getRoots = getRoots;
    // recursively build graphNode from nested element
    function scrapeDataNode(graph, parentId, nodeData, idKey, childKey, props, depth) {
        // create graph node as specified generic type node
        var graphNode = new BdGraphNode(nodeData[idKey]);
        // set Depth
        graphNode.setDepth(depth);
        // collect properties 
        Object.entries(props).forEach(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            var val;
            // get value (from string or function)
            if (typeof v === 'string') {
                val = nodeData[v];
            }
            else if (typeof v === 'function') {
                val = v(nodeData[idKey]);
            }
            // store as boolean or numerical state property
            if (typeof val === 'boolean') {
                graphNode.boolState[k] = val;
            }
            else if (typeof val === 'number') {
                graphNode.numState[k] = val;
            }
            else {
                graphNode[k] = val;
            }
        });
        // add node and relationships to graph
        graph.nodes[graphNode.id] = graphNode;
        if (parentId) {
            graph.successors[parentId] = __spread(graph.successors[parentId] || [], [graphNode.id]);
            graph.predecessors[graphNode.id] = parentId;
        }
        else {
            graph.roots[graphNode.id] = graphNode;
        }
        // recurse 
        depth += 1;
        nodeData[childKey].forEach(function (childData) {
            scrapeDataNode(graph, graphNode.id, childData, idKey, childKey, props, depth);
        });
    }
    // depth first traversal and do
    // this is a (private) utility 
    function depthFirst(graph, doFunc, id) {
        if (!id) {
            // start at the top fo the graph and operate on all roots
            getRoots(graph).forEach(function (rid) {
                doFunc(rid);
                depthFirst(graph, doFunc, rid);
            });
        }
        else {
            // act on node and keep going down
            doFunc(id);
            getSuccessors(graph, id).forEach(function (cid) {
                depthFirst(graph, doFunc, cid);
            });
        }
    }
    GraphUtils.depthFirst = depthFirst;
    // factory for new BdGraph nested objects 
    var DEFAULT_ID_KEY = 'id';
    var DEFAULT_CHILDREN_KEY = 'children';
    function createGraphFromSrc(srcData, idKey, childKey, nodeProperties) {
        if (idKey === void 0) { idKey = DEFAULT_ID_KEY; }
        if (childKey === void 0) { childKey = DEFAULT_CHILDREN_KEY; }
        if (nodeProperties === void 0) { nodeProperties = {}; }
        var depth = 0; // depth of root nodes is 0
        var graph = new BdGraph();
        srcData.forEach(function (nodeData) {
            scrapeDataNode(graph, null, nodeData, idKey, childKey, nodeProperties, depth);
        });
        return graph;
    }
    GraphUtils.createGraphFromSrc = createGraphFromSrc;
})(GraphUtils || (GraphUtils = {}));
